/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React from 'react';
import { DataContextProvider } from '@forge/data-connector';
import { Card, Icon, Tooltip } from '@scuf/common';
import { useTranslation } from '@scuf/localization';
// import '../../../scss/KPICardTheme.scss';
import EnergyStarWidget from './EnergyStarWidget';
import { ContextProvider, updateApiConfig } from '../../context/ApiContext';
import { shouldComponentNotUpdate } from '../shared/Utils/Utils';
import { IAny } from '../DashboardKPIWidgets/IEnergyManagementProps';

function EnergyStarWidgetContent(props: IAny) {
  const {
    connectorConfig,
    bearerToken,
    requestContext,
    onEnergyStarViewDetailsClick
  } = props;
  //   const d = descriptors.energyManagement;
  const [t] = useTranslation();
  return (
    // <ContextProvider
    //   value={updateApiConfig({
    //     connectorConfig,
    //     ...emaasContext
    //   })}
    // >
    <DataContextProvider config={connectorConfig}>
      <EnergyStarWidget
        requestContext={requestContext}
        bearerToken={bearerToken}
        siteEnergyScore={[]}
        onEnergyStarViewDetailsClick={onEnergyStarViewDetailsClick}
      />
    </DataContextProvider>
    // </ContextProvider>
  );
}

export default React.memo(
  EnergyStarWidgetContent,
  shouldComponentNotUpdate as IAny
);
